import { AuthContainer, AuthenticatorProvider } from "@pharaday/auth";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const SIGN_IN_SSO_URL_QUERY_KEY = "/auth/signin/sso-url";

export const useQuerySignInSsoUrl = (email: string) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: [SIGN_IN_SSO_URL_QUERY_KEY, email],
    queryFn: () => AuthContainer.get(AuthenticatorProvider).requestSignInSsoUrl(email),
    enabled: false,
  });

  const fetch = async () => {
    const cachedData = queryClient.getQueryData<{ ssoUrl: string }>([SIGN_IN_SSO_URL_QUERY_KEY, email]);
    if (cachedData) {
      return cachedData;
    }
    const { data: newData } = await query.refetch();
    return newData;
  };

  return {
    ...query,
    fetch,
  };
};
